import jsPDF from 'jspdf';
import {GlobalModels} from './global-models';

export module SwissInternModels {

    export interface SI_PDFRapport {
        invoice?: SI_Invoice;
        positions: GlobalModels.Dictionary<any>;
        type: string;
    }

    export interface SI_Invoice {
        template: any;
        doc: jsPDF;
        pdf: any;
        logo: any;
        completed: boolean;
        columns: any[];
        rows: any[];
        mandantAdr: any;
        pointer: number;
        output: any;
        name: string;
        address: any;
        MiscTablePos: any;
        data: any[];
        reset: boolean;
        relativepageadded: boolean;
        footerLogoPath: string;
        logoFooter: string;
        printPositionsTable: boolean;
    }


    export interface BaseFile {
        documentID: string;
        description: string;
        createdBy: string;
        createdDate: Date;
        objectID: string;
        fileName: string;
        binary: Blob;
        uploaded: boolean;
        lastModified?: Date;
    }

    export interface ObjektReportUploadElement {
        documentID: string;
        objectID: string;
        fileName: string;
        binary: Blob;
    }

    export interface StartSite {
        value: number;
        viewValue: string;
    }

    export interface TreeViewDisplaySettings {
        height: string;
        width: string;
        activeTouchBubble: boolean;
    }

    export const DEFAULT_OBJECT_SEARCH_SETTINGS: TreeViewDisplaySettings = {
        height: '40%',
        width: '300px',
        activeTouchBubble: true
    };
}
